<template>
  <div id="gcharts">
    <div id="chart_div"></div>
  </div>
</template>

<script>
import postscribe from 'postscribe'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('budget', ['budgetTotal']),
    ...mapGetters('project', ['currentProjectId'])
  },

  methods: {
    initChart () {
      google.charts.load('current', { packages: ['bar', 'corechart'] })

      const budgetTotal = this.budgetTotal(this.currentProjectId)

      const drawChart = () => {
        const data = google.visualization.arrayToDataTable([
          ['', this.$t('budget.chart.income'), this.$t('budget.chart.expenses'), this.$t('budget.chart.total')],
          [this.$t('budget.chart.budget'), budgetTotal.budgetIncome, budgetTotal.budgetExpenses, budgetTotal.budgetTotal],
          [this.$t('budget.chart.season'), budgetTotal.seasonIncome, budgetTotal.seasonTotalExpenses, budgetTotal.seasonTotal]
        ])

        const options = {
          chart: {
            title: '',
            subtitle: ''
          },
          bars: 'vertical',
          vAxis: { format: 'short' },
          height: 400,
          colors: ['#1b9e77', '#d95f02', '#7570b3']
        }

        const chart = new google.charts.Bar(document.getElementById('chart_div'))
        chart.draw(data, google.charts.Bar.convertOptions(options))
      }

      google.charts.setOnLoadCallback(drawChart)
    }
  },

  mounted () {
    postscribe('#gcharts', `<script type="text/javascript" src="https://www.gstatic.com/charts/loader.js"><\/script>`)// eslint-disable-line
    setTimeout(this.initChart, 500)
  }
}
</script>
